import * as React from "react";

import { LinkProps, Link as RouterLink } from "react-router-dom";

import { cn } from "@verse_core/shared_components/ClassName";

interface NavLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const NavLink = ({
  href,
  children,
  className,
  onClick,
}: NavLinkProps) => {
  const Link = RouterLink as unknown as React.ComponentType<LinkProps>;
  if (href.includes("https://")) {
    return (
      <a
        href={href}
        className={cn("tw-no-underline", className)}
        target={href.includes("versemedical.com") ? "_self" : "_blank"}
        rel="noopener noreferrer"
        onClick={onClick}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      className={cn("tw-no-underline", className)}
      to={href}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};
